import { Box, Button, useTheme } from '@mui/material'
import React from 'react'

import BasicModal from '@/shared/ui/Modal'
import { PlusIcon } from '@/shared/assets/icons/plusIcon'
import { RenderProfiles } from '@/widgets/ProfileScreen/UI/ProfileScreen'
import { useProfileScreenModal } from '../hooks/useProfileScreenModal'

export const ProfileScreenModal = ({
    shouldShowModal,
    setShouldShowModal,
}: {
    shouldShowModal: boolean
    setShouldShowModal?: (value: boolean) => void
}) => {
    const {
        isModalOpen,
        handleSetIsModalOpen,
        actualProfile,
        setIsModalOpen,
        profiles,
        setProfiles,
        setActualProfile,
    } = useProfileScreenModal(shouldShowModal, setShouldShowModal)

    const theme = useTheme()

    const closeButtonStyle = {
        transform: 'rotate(45deg)',
        width: 'max-content',
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
    }

    return (
        <Box>
            {isModalOpen && (
                <BasicModal
                    isOpen={isModalOpen}
                    setIsModalOpen={handleSetIsModalOpen}>
                    <Button
                        disableRipple
                        sx={closeButtonStyle}
                        onClick={() => {
                            actualProfile?.profile_name && setIsModalOpen(false)
                            setShouldShowModal && setShouldShowModal(false)
                        }}>
                        <PlusIcon fill={theme.palette.primary.main} />
                    </Button>
                    <RenderProfiles
                        profiles={profiles}
                        setProfiles={setProfiles}
                        lastUsedProfile={actualProfile}
                        setLastUsedProfile={setActualProfile}
                    />
                </BasicModal>
            )}
        </Box>
    )
}
